// UI texts: report
export default {
  expedition: 'Expedition #{n}',
  returnedAt: 'Returned {t}',
  leftAt: 'Left {t}',
  stamp: {
    returned: 'Returned',
    robbed: 'Robbed',
    retreated: 'Retreated',
    defeated: 'Knocked down',
    full: 'Pack full',
  },
  stance: 'Stance',
  fullEarly: 'Came back early: your pack was full.',
  fieldLog: 'Field log',
  keyMoment: 'Key moment',
  replay: 'Replay the key moment',
  big: { combat: 'Fight', overrun: 'Overrun', escape: 'Escape', trade: 'Trade', item: 'Find', horde: 'Holdout', retreat: 'Down', pvp: 'Fight', discovery: 'Discovery' },
  showAll: 'Show the full log ({n} more)',
  showLess: 'Show the short log',
  xp: 'XP',
  hpLost: 'HP lost',
  items: 'Items',
  lostCount: '{n} lost',
  levelUp: 'Level up',
  attrPoints: '+{n} attribute points',
  skillPoints: '+{n} skill point',
  skillPointsMany: '+{n} skill points',
  /** 29. 9. 2026: before level 5 the points wait for the tree. */
  skillPointsKept: '+{n} skill point · spend from level {lv}',
  assign: 'Assign →',
  xpTo: '{xp} / {next} XP to Lv {lv}',
  maxLevel: 'Max level reached',
  rankTo: '{xp} / {next} XP to Rank {rank}',
  loot: 'Loot',
  lootNote: '{n} items · {m} new',
  lootNoteOne: '1 item · {m} new',
  lootNoteLost: '{n} kept · {m} lost',
  leftBehind: 'Left behind: {list} (Storage full).',
  /** 23. 10. 2026 (owner, pilot report): with Tobias at camp, what did not fit is his for a little Scrap. */
  overflowSold: "Tobias bought what didn't fit: {list}: +{n} Scrap.",
  lootEmpty: 'Came back with empty pockets.',
  /** K9b: Scrap taken on the way (PvP), on the Scrap row. */
  scrapLost: '−{n} lost',
  doubled: 'Doubled',
  sendAgain: 'Send again',
  /** 2. 10. 2026 (package 1, 5.c): one tap, the remembered orders (stance, retreat, lists, meal, bandages). */
  sameOrders: 'Same orders · {m}',
  changeOrders: 'Change orders',
  sameBlocked: {
    hp: 'Too hurt for the same orders. Heal first, or change the orders.',
    load: 'Overloaded: take something off before the same orders.',
    energy: 'Not enough energy for the same orders yet.',
    busy: 'Your survivor is already out there.',
    locked: 'That zone is closed for you now.',
    key: 'No key left for that zone.',
  },
  /** 11.b: the first run's report, right under its loot. */
  ping: {
    title: 'Next runs take longer',
    body: 'Get a ping when your survivor is back. Timers are grouped: at most one ping every 30 minutes.',
    button: 'Tell me when {name} is back',
  },
  backToHorde: 'Back to the horde',
  backToGroup: 'Back to the crew',
  revenge: 'Revenge available',
  revengeLine: '{name} · Lv {lv} · window closes in {t}',
  /** Package 4, part E (6): where the revenge run goes. */
  huntRun: 'They are out in {zone} now. Your run goes there.',
  huntTracks: 'Their freshest tracks are in {zone}. Your run goes there.',
  revengeScreen: {
    title: 'Revenge',
    closed: 'That revenge window has closed.',
    later: 'The window stays open for its 24 hours: try again when they are out.',
    camp: 'Back to camp',
  },
  share: 'Share story',
  camp: 'Go to camp',
  notFoundTitle: 'Report not found',
  notFoundBody: 'This expedition does not exist or belongs to someone else.',
  /** Krug 5 (K12.11): the meal's line next to the summary. */
  meal: {
    ration: '{name}: +{n} max HP',
    stew: '{name}: healed {n} times (+{hp} HP)',
    stewOne: '{name}: healed once (+{hp} HP)',
    stewNone: '{name}: no won fight to heal after',
    feast: '{name}: +{n} XP',
    jerky: '{name}: {effect} escape',
    beans: '{name}: fewer encounters',
    effect: '{name}: {effect}',
  },
  ad: {
    label: 'Ad · {n}',
    sponsored: 'Sponsored',
    title: 'A word from the wasteland',
    body: 'Your reward lands when the timer runs out.',
    cancel: 'Skip, no reward',
    claiming: 'Doubling your loot…',
  },
  live: {
    title: 'On expedition',
    stamp: 'Out there',
    sub: '{name} is out in {zone}. The log fills in as it happens.',
    backIn: 'Back in',
    arriving: 'Arriving any moment',
    eta: 'back at {t}',
    recalled: 'Recalled · heading home, back at {t}',
    recall: 'Recall',
    recallHint: 'Comes home after the current area. Keeps what is in the pack.',
    finishNow: 'Finish now',
    finishNowHint: 'Borrowed Time · once a day. The areas left play out at once, with your orders.',
    camp: 'Back to camp',
    stillOut: 'Still out there…',
    nothingYet: 'Nothing to report yet. Give it a few minutes.',
    /** 2. 10. 2026 (package 1, 11.a): a new player's first two runs. One line per area, split at "|". */
    narration: '{name} walks into the treeline, eyes on the ground.|{name} checks a wreck by the road. Something rattles inside.|{name} turns for home, pack heavier than before.',
    backInSeconds: 'Back in {s} seconds.',
    backInOne: 'Back in 1 second.',
    stay: 'Stay here: the report opens as soon as the run is back.',
    decision: 'Decision needed',
    decisionBody: 'Your survivor ran into someone and is waiting for your call.',
    decide: 'Decide now',
  },
  shareSheet: {
    title: 'Share story',
    post: 'Post',
    story: 'Story',
    share: 'Share',
    copy: 'Copy link',
    download: 'Download PNG',
    hint: 'Anyone with the link can read this story, no account needed.',
  },
} as const;
